import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Table, Modal } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
// import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import * as Common from '../../Common';
import Dialog from '../../Dialog';
// import '../../mcss/common.css';
import RequestHeader from '../RequestHeader';
import TransactionComment from '../TransactionComment';
import $ from 'jquery';
import Ad1RequestHeader from './Ad1RequestHeader';
import AD1TransactionComment from './AD1TransactionComment';


function Ad1CoverRate(props) {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [reqSrNo, setReqSrNo] = useState(0);
    const [reqQuantity, setReqQuantity] = useState(0);
    const [reqCoverBank, setReqCoverBank] = useState("0");
    const [ddCoverBank, setDdCoverBank] = useState([]);
    const [reqCoverBankName, setReqCoverBankName] = useState("");
    const [reqCoverValue, setReqCoverValue] = useState("");
    const [reqCoverRate, setReqCoverRate] = useState("");
    const [reqCoverDeal, setReqCoverDeal] = useState("");
    const [reqCoverValDate, setReqCoverValDate] = useState(new Date());
    const [reqCoverFinal, setReqCoverFinal] = useState(0);
    const [coverListData, setCoverListData] = useState([]);
    const [reqCoverTotValue, setReqCoverTotValue] = useState(0);
    const [reqData, setReqData] = useState([]);
    const [showReject, setShowReject] = useState(false);
    const [showConfirmBox, setShowConfirmBox] = useState(false);
    const [remark, setRemark] = useState("");
    const [viewObj, setViewObj] = useState();
    const [status,setStatus]=useState(0);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'AD1COVERRATE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    Common.callApi(Common.apiAd1, [sid, 'view', JSON.stringify({ srno: props.srno })], function (result) {
                        let resp = JSON.parse(result);
                        console.log(resp);
                        setViewObj(resp[0]);
                        setReqCoverBank(resp[0].trad_bank_code);
                        setReqCoverValue(resp[0].trad_quantity);
                        setReqSrNo(resp[0].trad_srno);
                        setReqQuantity(resp[0].trad_quantity);
                        setReqCoverFinal(resp[0]?.trad_coverfinal);
                        setStatus(resp[0]?.trad_status);
                        // setReqCoverTotValue(resp[0].trad_quantity);
                        setReqCoverBankName(resp[0].issuer_name);
                        Common.callApi(Common.apiad1coverrate, [sid, 'list', props.srno], function (result) {
                            var arr = JSON.parse(result)
                            setCoverListData(arr);
                        });
                        Common.callApi(Common.apiIssuer, [sid, 'ddlistjson'], function (result) {
                            let parsed = JSON.parse(result || "[]");
                            setDdCoverBank(Array.isArray(parsed) ? parsed : []);
                        });
                    });
                    // Common.callApi(Common.apiRight, [sid, 'all', 'AD1COVERRATE'], function (result1) {
                    //     setCoverRight(JSON.parse(result1));
                    // });
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);

    function handleReqCoverBank(v, t) {
        setReqCoverBank(v);
        setReqCoverBankName(t);
    }

    function btnBackClick() {
        props.callAd1();
    }
    function btnDraftClick() {
        saveCover("D");//D means draft
    }
    function btnFinalClick() {
        console.log(reqQuantity, "Final Click", reqCoverTotValue);
        if (reqCoverTotValue * 1 === reqQuantity * 1) {
            setShowConfirmBox(true);
        } else {
            setMsgText("Requested Quantity is not equal to Cover Quantity. It can not be finalized.");
            setMsgBox(true);
        }
    }

    function saveCover(saveMode) {
        setShowConfirmBox(false);
        let object1 = {
            srno: props.srno,
            saveMode: saveMode,
            coverDetail: coverListData
        }
        Common.callApi(Common.apiad1coverrate, [sid, 'saveCover', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                if (saveMode === "F") {
                    setReqCoverFinal(1);
                }
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function btnAddCoverClick() {
        if (reqCoverBank === "0" || reqCoverBank === "" || reqCoverRate === "" || reqCoverDeal === "" || parseFloat(reqCoverRate) === 0
            || reqCoverValue === "" || reqCoverValue === "0" || reqCoverValue === 0 || reqCoverValue < 0
        ) {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {

            setCoverListData(Common.arrayAddItem(coverListData, {
                "srno": props.srno,
                "bankId": reqCoverBank,
                "banknm": reqCoverBankName,
                "cvalue": reqCoverValue,
                "rate": reqCoverRate,
                "dealId": reqCoverDeal,
                "vdate": Common.dateDMY(reqCoverValDate)
            }));
            if ((reqQuantity * 1 - reqCoverTotValue * 1 - reqCoverValue * 1).toFixed(2) >= 0) {
                setReqCoverValue((reqQuantity * 1 - reqCoverTotValue * 1 - reqCoverValue * 1).toFixed(2));
            } else {
                setReqCoverValue(0)
            }
            setReqCoverTotValue((reqCoverTotValue * 1 + reqCoverValue * 1));
            setReqCoverRate("");
            setReqCoverDeal("");
            setRefreshCounter(refreshCounter + 1);
            // console.log(JSON.stringify(coverListData,null,' '));
        }
    }

    function btnDeleteCoverClick(srno, value) {
        if ((reqQuantity * 1 - reqCoverTotValue * 1 + value * 1).toFixed(2) >= 0) {
            setReqCoverValue((reqQuantity * 1 - reqCoverTotValue * 1 + value * 1).toFixed(2));
        } else {
            setReqCoverValue(0)
        }
        setReqCoverTotValue((reqCoverTotValue - value).toFixed(2));
        setCoverListData(Common.arrayRemoveItem(coverListData, "srno", srno));
        setRefreshCounter(refreshCounter + 1);

    }
    function btnRejectClick() {
        var object1 = {
            srno: reqSrNo
        }
        Common.callApi(Common.apiad1coverrate, [sid, 'reject', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setReqCoverFinal(0);
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function btnChngQtyClick(flag) {
        var object1 = {
            srno: reqSrNo,
            status: flag
        }
        Common.callApi(Common.apiad1coverrate, [sid, 'approvechangeqty', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                btnBackClick();
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function handleShowReject() {
        setShowReject(!showReject);
    }

    function btnUnlockCover() {
        var object1 = {
            srno: reqSrNo
        }
        Common.callApi(Common.apiad1coverrate, [sid, 'unlockcover', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                setReqCoverFinal(0);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function btnAddComment() {
        var object1 = {
            srno: props.srno,
            cmnt: remark
        }
        Common.callApi(Common.apiPaymentApprove, [sid, 'addcomment', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setRemark("");
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setRefreshCounter(refreshCounter + 1);
        });
    }


    return (
        <>
            <div className="divCostumForm">
                <Container fluid>
                    <Row>
                        <Col>
                            <h1>Ad1 Cover Rate</h1>
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row> */}
                    <Row>
                        <Col>
                            <Ad1RequestHeader back={btnBackClick} rhdata={reqData} viewData={viewObj}></Ad1RequestHeader>
                        </Col>
                    </Row>
                    {coverListData?.trac_user &&
                        <Row>
                            <Col className='col-md-4'>
                                <b>{coverListData?.trac_user} : {coverListData?.um_username}</b>
                            </Col>
                        </Row>
                    }
                    {(reqCoverFinal * 1 === 0 && (userRight.add * 1 === 1 || userRight.edit * 1 === 1)) ?
                        <>
                            <Row>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Bank<span className="mandatory">*</span></Form.Label>
                                        <Form.Select
                                            disabled={coverListData.length !== 0}
                                            value={reqCoverBank}
                                            onChange={(e) => handleReqCoverBank(e.target.value, e.target.options[e.target.selectedIndex].text)}  >
                                            {/* {ddCoverBank.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )} */}
                                            {Array.isArray(ddCoverBank) && ddCoverBank.map((res) =>
                                                <option key={res.value} value={res.value}>{res.name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Cover Quantity<span className="mandatory">*</span> <b>({viewObj?.trad_currency_name}) ({reqData?.req_tenure})</b></Form.Label>
                                        <Form.Control type="text" placeholder="Cover Quantity" maxLength={10} autoComplete="off"
                                            value={reqCoverValue}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqCoverValue)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Cover Rate<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Cover Rate" maxLength={10} autoComplete="off"
                                            value={reqCoverRate}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqCoverRate)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Deal Number<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Deal Number" maxLength={50} autoComplete="off"
                                            value={reqCoverDeal}
                                            onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setReqCoverDeal)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Expiry Date<span className="mandatory">*</span></Form.Label>
                                        <DatePicker className="form-control"
                                            selected={reqCoverValDate}
                                            onChange={(date) => setReqCoverValDate(date)}
                                            isClearable={coverListData.length === 0}
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            useShortMonthInDropdown
                                            dropdownMode="select"
                                            peekNextMonth
                                            customInput={
                                                <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                            }
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                        <Button variant="outline-primary" size="sm" onClick={(e) => btnAddCoverClick()} >Add</Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </>
                        : null
                    }

                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={
                                (reqCoverTotValue * 1 - reqQuantity * 1) > 0 ? "divDanger" : "divNormal"
                            }
                            >
                                <b>Total Cover : {reqCoverTotValue}</b>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td></td>
                                        <td className='divHide'></td>
                                        <td>Cover Bank</td>
                                        <td>Cover Quantity</td>
                                        <td>Cover Rate</td>
                                        <td>Deal Number</td>
                                        <td>Expiry Date</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {coverListData.map((res) =>
                                        <tr key={res.srno}>
                                            <td>
                                                {
                                                    reqCoverFinal * 1 === 0 ?
                                                        <>
                                                            <div className="colorThemeBlue">
                                                                <span className="handCursor" onClick={(e) => btnDeleteCoverClick(res.srno, res.cvalue)}>
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </span>
                                                            </div>
                                                        </>
                                                        : null
                                                }

                                            </td>
                                            <td className='divHide'>{res.srno}</td>
                                            <td>{res.bankId + ' : ' + res.banknm}</td>
                                            <td>{res.cvalue}</td>
                                            <td>{res.rate}</td>
                                            <td>{res.dealId}</td>
                                            <td>{(res.vdate)?.split('-')?.reverse()?.join('/')}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                            {
                                (viewObj?.trad_coverfinal * 1 === 0 && reqCoverFinal===0  && (userRight.add * 1 === 1 || userRight.edit * 1 === 1) && status==1) ?
                                    <>
                                        { }
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnDraftClick()} >Draft</Button>&nbsp;
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnFinalClick()} >Final</Button>&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                    </>
                                    : null
                            }
                            {
                                // && reqData.req_bankfilegenrated * 1 === 0
                                ((userRight.add * 1 === 1) && viewObj?.trad_status === "1") && status==1 &&
                                <>
                                    <input type="checkbox" checked={showReject} onChange={handleShowReject} />&nbsp;&nbsp;
                                    {showReject ?
                                        <>
                                            <Button variant="outline-danger" size="sm" onClick={(e) => btnRejectClick()}>Reject</Button>
                                            &nbsp;&nbsp;
                                            <Button variant="outline-danger" size="sm" onClick={(e) => btnUnlockCover()}>Unlock Cover</Button>
                                        </>
                                        : null
                                    }
                                </>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <AD1TransactionComment srno={props.srno} rc={refreshCounter}></AD1TransactionComment>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <Modal
                show={showConfirmBox}
                onHide={() => setShowConfirmBox(false)}
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Cover Final Confirmation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            Are you sure to lock the cover ? Locked cover can not be modified.
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-success" size="sm" onClick={(e) => saveCover("F")} >Yes</Button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button variant="outline-danger" size="sm" onClick={(e) => saveCover("D")} >No</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}
export default Ad1CoverRate;